import { HEADER_HORIZONTAL_PADDING } from "../constants";
export var getIsMenuHidden = function getIsMenuHidden(menuWidth, navigationItemsWidth, logoWidth) {
  return menuWidth - HEADER_HORIZONTAL_PADDING <= navigationItemsWidth + logoWidth;
};